import React, { useRef, useState } from "react";
import CreatableSelect from "react-select/creatable";

const isNumeric = (value) => {
  return /^\d*\.?\d*$/.test(value);
};

const MoneyDropdownInput = ({
  field,
  form,
  defaultOptions,
  currency,
  ...props
}) => {
  const regex = new RegExp(`[${currency},]`, "g");
  const focusedRef = useRef(false);

  const initialOptionValue = field.value
    ? { label: String(field.value), value: field.value }
    : defaultOptions[0];
  const [inputValue, setInputValue] = React.useState(
    field.value ? String(field.value) : ""
  );
  const [value, setValue] = React.useState(initialOptionValue);
  const [options, setOptions] = useState(
    field.value ? defaultOptions.concat(initialOptionValue) : defaultOptions
  );
  const [menuOpen, setMenuOpen] = useState(false);

  const selectProps = {
    ...props,
    className: "select-container",
    classNamePrefix: "select",
    name: field.name,
    options,
    styles: {
      menuPortal: (base) => ({ ...base, zIndex: 9999999999999 }),
      ...props.styles,
    },
  };

  const createOption = (label) => ({ label, value: label });
  const isInDefaultOptions = (value) =>
    defaultOptions.some((option) => option.label === value);

  const onChange = (newValue) => {
    if (isInDefaultOptions(newValue.label)) {
      setValue(defaultOptions[0]);
      setTimeout(() => form.setFieldValue(field.name, 0), 0);
    }
  };

  const parseCurrency = (value) => {
    if (!value) return 0;
    return parseFloat(value.replace(regex, ""));
  };

  const formatCurrency = (number) => {
    if (isInDefaultOptions(number)) return number;
    const parsedNumber = number.replace(regex, "");
    return `${currency}${Number(
      parseCurrency(parsedNumber || 0)
    ).toLocaleString("en-US")}`;
  };

  const onInputChange = (newValueWithCurrency) => {
    const newValue = newValueWithCurrency.replace(regex, "") ?? "";
    if (!isNumeric(newValue) || (!newValue && !focusedRef.current)) return;
    setInputValue(newValue);
    setTimeout(() => form.setFieldValue(field.name, newValue === "" ? 0 : newValue), 0);
    handleCreate(newValue);
  };

  const handleCreate = (inputValue) => {
    if (inputValue) {
      const newOption = createOption(inputValue);
      setOptions((prev) => [...prev, newOption]);
      setValue(newOption);
    } else if (!isInDefaultOptions(value?.label)) setValue(null);
  };

  const handleBlur = () => {
    if (!inputValue) return;
    handleCreate(inputValue);
    focusedRef.current = false;
  };

  const handleFocus = () => {
    focusedRef.current = true;
  };

  const handleMenuOpen = () => {
    setMenuOpen(true);
  };

  const handleMenuClose = (e) => {
    setMenuOpen(false);
  };

  return (
    <CreatableSelect
      {...selectProps}
      className="select-container"
      inputValue={inputValue ? formatCurrency(inputValue) : inputValue}
      filterOption={(option) => isInDefaultOptions(option.label)}
      onChange={onChange}
      onInputChange={onInputChange}
      onCreateOption={handleCreate}
      value={value}
      onBlur={handleBlur}
      onFocus={handleFocus}
      menuIsOpen={menuOpen}
      onMenuOpen={handleMenuOpen}
      onMenuClose={handleMenuClose}
    />
  );
};

export default MoneyDropdownInput;
